export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingservice) {
        ele.addEventListener('keydown', event => {
            if (
                event.target.matches("[type='radio']") &&
                event.which === 13 /* Enter */
            ) {
                event.target.click();
                event.preventDefault();
                event.stopPropagation();
            }
        });

        ele.addEventListener('change', trackFilterSelection);

        function trackFilterSelection(event) {
            const button = event.target;
            if (button.checked) {
                trackingservice.trackEventObject({
                    analyticsName: `navigation.filter-by-${button.name.replace(
                        /_/g,
                        ''
                    )}.click`,
                    stringValue: `${button.name}:${button.value}`,
                });
            }
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/rangeRadioButton.js